import React, { useState } from "react";
import {
    Col, Container, Row,
} from "reactstrap";
import "assets/scss/website/app.scss";
import { MetaTags } from "react-meta-tags"; 
import "react-rangeslider/lib/index.css"; 
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';

 
const CreateResale = (props) => {
    const { t } = useTranslation();
    const [agree, setAgree] = useState(false)

    const list = [{
        title: t("title1"),
        subTitle: t("subTitle1")
    }, {
        title: t("title2"),
        subTitle: t("subTitle2")
    }, {
        title: t("title3"),
        subTitle: t("subTitle3")
    }, {
        title: t("title4"),
        subTitle: t("subTitle4")
    }, {
        title: t("title5"),
        subTitle: t("subTitle5")
    }]


    const handleInputChange = (event) => {
        const value = event.target.checked;
        setAgree(value)
    }
    return (
        <div className="resalePage ">
            <MetaTags>
                <title>{t("conditions and terms")}</title>
            </MetaTags>
            <div>
                <Container fluid className="px-lg-5 pb-5 pt-10rem px-3">
                    <Row className="d-flex justify-content-between mb-4">
                        <Col md={11} className="h4 m-0 p-0 d-flex justify-content-start">{t("Add New Listing")}</Col>
                    </Row>
                    <Row>
                        {list.map((item, index) => {
                            return (


                                <Col md={12} className="px-0" style={{ verticalAlign: "middle" }}>
                                    <div
                                        className="d-inline-block p-1 py-2 font-size-18 fw-bold text-center my-0"
                                        style={{ background: "#a8a8a8", width: "40px", borderRadius: "50%" }}
                                    >{index + 1}</div>
                                    <div

                                        className="d-inline-block  mx-2 my-0  "
                                    >
                                        <h5 className="my-0 pt-2">{item.title}</h5>
                                        <p className="" style={{ textIndent: "4px", textAlign: "start" }}>{item.subTitle}</p>

                                    </div>

                                </Col>
                            )
                        })}
                    </Row>
                    <p className="font-size-16 fw-bold mt-3">{t("conditions and terms")}</p>

                    <Row>
                        <Col>
                            <p>{t("rule-1")}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <label>
                                <input
                                    name="isGoing"
                                    type="checkbox"
                                    checked={agree}
                                    onChange={handleInputChange} />
                                 {t("I agree")}
                            </label>
                        </Col>
                    </Row>
                </Container>
                <div className="mx-lg-4 d-flex justify-content-between pb-4 px-lg-3 px-3">
                    <button
                        type="button"
                        className="btn btnUpload btnHeight px-4"
                        onClick={() => {
                            props.history.goBack()
                        }}
                        size={"lg"}>
                        {t("Cancel")}
                    </button>
                    <button
                        type='button'
                        className="btn btn-success btnHeight px-4 float-end"
                        size={"lg"}
                        onClick={() => {
                            if (agree) {
                                props.history.push("/create-resale")
                            } else {
                                toast.error(t("Agree on Terms to Can Add Property"))
                            }
                        }}

                    >
                        {t("Submit")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateResale;
